/* eslint-disable */
/**
 * Application constants
 */

export function ON_MOBILE_DEVICE() {
  return (
    (window.cordova || window.PhoneGap || window.phonegap) &&
    /^file:\/{3}[^\/]/i.test(window.location.href) &&
    /ios|iphone|ipod|ipad|android/i.test(navigator.userAgent)
  );
}

/**
 * LocalStorage constants
 */
export const LOCALSTORAGE_TOKEN = "token";
export const LOCALSTORAGE_USER_ID = "user_id";
export const LOCALSTORAGE_USER_IS_MANAGER = "is_manager";



// WEBPACK FOOTER //
// ./src/config.js